document.addEventListener('DOMContentLoaded', () => {
  const sliderSmall = new Swiper('.lectors__slider--small', {
    slidesPerView: 2,
    watchSlidesProgress: true,

    lazy: {
      loadPrevNext: true,
      checkInView: true,
    },

    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      490: {
        slidesPerView: 2,
      },

      640: {
        slidesPerView: 3,
      },
    },
  });
  const sliderLarge = new Swiper('.lectors__slider--large', {
    slidesPerView: 1,

    thumbs: {
      swiper: sliderSmall,
    },
    pagination: {
      el: document.querySelector('.lectors .control .control__pagination'),
      type: 'fraction',
    },
    lazy: {
      loadPrevNext: true,
      checkInView: true,
    },
    navigation: {
      nextEl: document.querySelector('.lectors .control__arrow--next'),
      prevEl: document.querySelector('.lectors .control__arrow--prev'),
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      440: {
        slidesPerView: 2,
        spaceBetween: 15,
      },

      768: {
        slidesPerView: 1,
      },
    },
  });
});
